import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const serviceRateRoutes: RouteObject[] = [
  {
    path: '/service-rate',
    element: lazyElement(() => import('./Main')),
    handle: { crumb: () => ({ label: 'Service Rates', to: '/service-rate' }) },
  },
];

export default serviceRateRoutes;

